<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <div
      id="editpartner"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="px-2 mb-0">
                {{ mode === "edit" ? $t("edit_partner") : $t("add-partner") }}
              </h5>
              <p class="cursor-pointer px-2" @click="onCancel">
                <img src="../../assets/images/Vector (1).png" alt="" />
              </p>
            </div>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>

            <form class="p-2" @submit.prevent="handleSubmit">
              <div class="form-group">
                <label for="name">{{ $t("company-name") }}</label>
                <input
                  type="text"
                  name="name"
                  v-model="name"
                  class="form-control"
                  required
                  id="name"
                  :placeholder="$t('enter-full-name')"
                  @keypress="isLetter($event)"
                />
              </div>

              <div class="form-group">
                <label for="email">{{ $t("email") }}</label>
                <input
                  v-model="email"
                  type="text"
                  name="email"
                  class="form-control"
                  required
                  id="email"
                  :placeholder="$t('enter-email')"
                />
              </div>

              <div class="form-group w-100">
                <label for="phone">{{ $t("phone_num") }}</label>
                <input
                  type="tel"
                  v-model="phoneNumber"
                  class="form-control"
                  required
                  id="phone_number"
                  :placeholder="$t('enter-phonenumber')"
                />
                <p v-if="ErrorPhone" class="my-0 small text-error p-1">
                  {{ ErrorPhone }}
                </p>
              </div>

              <div class="form-group w-100">
                <label for="phone">{{ $t("company-address") }}</label>
                <input
                  type="text"
                  v-model="companyAddress"
                  class="form-control"
                  required
                  id="phone"
                  :placeholder="$t('enter-companyAddress')"
                />
              </div>

              <div style="display: flex; justify-content:right;">
                <button type="submit" class="btn btn-primary btn-edit">
                  {{ mode === "edit" ? $t("save") : $t("add") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";

import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";

export default {
  name: "EditPartner",
  components: {
    Loading,
  },

  props: {
    show: Boolean,
    mode: {
      type: String,
      default: "edit", 
    },
    partner: Array,
  },

  mounted() {
    if (this.mode === "edit") {
      this.initialiseForm();
    } else {
      this.iti = intlTelInput(document.querySelector("#phone_number"), {
        separateDialCode: true,
        utilsScript: utils,
      });
    }
  },

  data() {
    return {
      isLoading: false,
      fullPage: true,
      name: "",
      email: "",
      phoneNumber: "",
      companyAddress: "",
      mssg: "",
      Errormssg: "",
      ErrorPhone: "",

      iti: "",
    };
  },

  directives: {
    clickOutside: vClickOutside.directive,
  },

  methods: {
    ...mapActions(["addPartner", "getPartner", "editPartner"]),

    onCancel() {
      this.$emit("closeEditPartnerModal");
    },

    initialiseForm() {
      if (this.mode === "edit") {
        setTimeout(() => {
          this.name = this.partner[0].name;
          var input = document.querySelector("#phone_number");
          this.iti = intlTelInput(input, {
            separateDialCode: true,
            utilsScript: utils,
          });
          var number = "+" + this.partner[0].phoneNumber.toString();
          this.iti.setNumber(number);

          this.phoneNumber = this.partner[0].phoneNumber;
          this.email = this.partner[0].email;
          this.companyAddress = this.partner[0].address;
        }, 200);
      }
    },

    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      else e.preventDefault();
    },

    validatePhoneNumber() {
      this.ErrorPhone = "";
      if (this.iti.isValidNumber()) {
        return true;
      } else {
        this.ErrorPhone = this.$t("valid_phone");
        return false;
      }
    },

    handleSubmit() {
      if (this.mode === "edit") {
        this.editpartner();
      } else {
        this.addpartner();
      }
    },

    editpartner() {
      let number = this.iti.getNumber().slice(1);
      this.ErrorPhone = "";
      if (!this.iti.isValidNumber()) {
        this.ErrorPhone = this.$t("valid_phone");
      } else {
        this.isLoading = true;
        this.Errormssg = "";
        const newPartner = {
          phoneNumber: `${parseInt(number)}`,
          name: this.fullname,
          address: this.address,
          email: this.email,
        };
        this.editPartner({ newPartner, id: this.partner[0].id })
          .then((res) => {
            this.getPartner().then(() => {
              this.onCancel();
            });
            this.$emit("showSuccessPopup", {
              msg: this.$t("edit_msg_partner"),
              heading: this.$t("edit_heading_partner"),
            });
            this.isLoading = false;
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },

    addpartner() {
      console.log(this.name, this.email, this.phoneNumber, this.companyAddress);
      if (!this.validatePhoneNumber(this.number)) {
        this.ErrorPhone = this.$t("valid_phone");
        return;
      }
      this.isLoading = true;
      const newPartner = {
        name: this.name,
        address: this.companyAddress,
        email: this.email.toLowerCase(),
        phoneNumber: this.phoneNumber,
      };

      this.addPartner(newPartner)
        .then((res) => {
          this.getPartner();
          this.onCancel();
          this.$emit("partnerDetails", newPartner);
          this.isLoading = false;
          this.$emit("showSuccessPopup", {
            msg: this.$t("success_msg_partner"),
            heading: this.$t("success_heading_partner"),
          });
        })
        .catch((error) => {
          console.error("Error adding contact:", error);
          this.isLoading = false;
          this.Errormssg = "Error adding contact. Please try again.";
        });
    },
  },

  watch: {
    partner: {
      handler: function() {
        console.log("watch ");
        this.initialiseForm();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 410px !important;
}
</style>
